import React, { Component } from 'react';
import { AuthenticatedUser } from '~/Api/Authentication';
import { BrowserAccessTokenStorage } from '~/ApiClient';
import { Link } from '~/UI/Button';

import styles from './styles.less';

interface Props {
	user: AuthenticatedUser | null;
	onFetch(): void;
}

export default class UserNavigationItem extends Component<Props> {
	static defaultProps = {
		user: null,
	};

	componentDidMount() {
		const token = new BrowserAccessTokenStorage('access-token', {
			path: '/',
			httpOnly: false,
		}).loadToken();

		if (token) {
			this.props.onFetch();
		}
	}

	render() {
		const { user } = this.props;

		return user !== null ? (
			<Link styles={styles} to='/profile'>
				{user.name !== null ? user.name : user.email}
			</Link>
		) : null;
	}
}
